import { ReactComponent as AsteriskIcon } from 'assets/icons_3/asterisk.svg';
import React, { FC } from 'react';
import classNames from 'classnames';
import style from './FormLabel.module.scss';

interface IFormLabelProps extends Omit<React.HTMLProps<HTMLLabelElement>, 'size'> {
  required?: boolean;
}

const FormLabel: FC<IFormLabelProps> = ({
  className, required, children, htmlFor, ...props
}) => (
  <label className={classNames(style.label, className)} htmlFor={htmlFor} {...props}>
    {children}
    {required && (<AsteriskIcon className={style.asterisk} />)}
  </label>
);
export default FormLabel;
